import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import "./stores.scss";

const Stores = () => {
    const { id } = useParams();

    const permissions = useSelector((state) => state.status.permissions);

    const { data: stores, refetch: refetchStores } = useGetPageQuery("stores?per_page=200&all_stores=1&active=" + id);
    const [deleteStore, { isLoading, isError }] = useSendFormMutation();

    const [storeList, setStoreList] = useState([]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setStoreList([...storeList, e.target.value]);
        } else if (!e.target.checked) {
            setStoreList([...storeList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteStoresHandler = async () => {
        for (const store of storeList) {
            await deleteStore({ body: {}, url: "stores/" + store, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchStores();
    };

    const checkAllHandler = () => {
        setStoreList(stores.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetchStores();
        };
        refetch();
    }, [stores]);

    return (
        <>
            {stores && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>Магазини</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link
                                        to={"/store"}
                                        className="add btn btn-primary"
                                    >
                                        Додати магазин
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <ul className="nav-bordered nav nav-tabs mb-3">
                            <li className="nav-item">
                                <Link
                                    to={"/stores/1"}
                                    className={+id === 1 ? "nav-link active" : "nav-link"}
                                >
                                    <span className=" d-lg-block">Активні</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to={"/stores/0"}
                                    className={+id === 0 ? "nav-link active" : "nav-link"}
                                >
                                    <span className=" d-lg-block">Деактивовані</span>
                                </Link>
                            </li>
                        </ul>
                        <div id="list_form">
                            <a
                                className="check_all"
                                onClick={checkAllHandler}
                            >
                                Виділити все
                            </a>
                            <table className={+id === 0 ? "table disabled_status" : "table table-striped"}>
                                <thead>
                                    <tr>
                                        <th data-field="check"></th>
                                        <th
                                            data-field="id"
                                            className="no-mobile"
                                        >
                                            ID
                                        </th>
                                        <th data-field="user_name">Назва</th>
                                        <th
                                            data-field="user_address"
                                            className="no-mobile"
                                        >
                                            Адреса
                                        </th>
                                        <th
                                            data-field="user_status"
                                            className="no-mobile"
                                        >
                                            Статус
                                        </th>
                                        <th
                                            data-field="is_show_in_services"
                                            className="no-mobile"
                                        >
                                            В сервісах
                                        </th>
                                        <th
                                            data-field="user_telegram"
                                            className="no-mobile"
                                        >
                                            Telegram
                                        </th>
                                        <th
                                            data-field="user_telegram"
                                            className="no-mobile"
                                        >
                                            Sale
                                        </th>
                                        <th
                                            data-field="user_telegram"
                                            className="no-mobile"
                                        >
                                            Accessories
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stores.data.map((store) => {
                                        return (
                                            <tr
                                                className=""
                                                key={store.id}
                                            >
                                                <td className="check_area text-right">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={storeList.includes(store.id.toString())}
                                                            value={store.id}
                                                            onChange={(e) => listCheckHandler(e)}
                                                        />
                                                        <label className="custom-control-label">&nbsp;</label>
                                                    </div>
                                                </td>
                                                <td className="no-mobile">#{store.id}</td>
                                                <td>
                                                    <Link
                                                        to={`/store/` + store.id}
                                                        data-id="38"
                                                    >
                                                        {store.title}
                                                    </Link>
                                                </td>
                                                <td className="no-mobile">{store.address}</td>
                                                <td className="no-mobile">
                                                    {store.active ? "Активний" : "Деактивованый"}
                                                </td>
                                                <td className="no-mobile">{!!store.is_show_in_services ? "+" : ""}</td>
                                                <td className="no-mobile">{store.telegram_id}</td>
                                                <td className="no-mobile">{store.telegram_sale_id}</td>
                                                <td className="no-mobile">{store.telegram_accessories_id}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {permissions.includes("store_edit") || permissions.includes("all") ? (
                                <div className="d-flex">
                                    <select
                                        name="action"
                                        className="form-select"
                                        style={{ width: "auto" }}
                                    >
                                        <option value="delete">Видалити</option>{" "}
                                    </select>
                                    <button
                                        className="btn btn-info mx-3"
                                        onClick={deleteStoresHandler}
                                    >
                                        {" "}
                                        {isLoading ? "Завантаження" : "Виконати"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Stores;
